if (!customElements.get('cart-offer-progress')) {
  customElements.define(
    'cart-offer-progress',
    class CartOfferProgress extends HTMLElement {
      // Kept across drawer re-renders so the new bar starts where the old one was, then slides.
      static lastScrollLeft = 0;

      connectedCallback() {
        this.viewport = this.querySelector('.cart-offer__viewport');
        this.navButtons = this.querySelectorAll('.cart-offer__nav');
        if (!this.viewport) return;

        this.viewport.scrollLeft = CartOfferProgress.lastScrollLeft;
        this.viewport.addEventListener(
          'scroll',
          () => {
            CartOfferProgress.lastScrollLeft = this.viewport.scrollLeft;
            this.updateNav();
          },
          { passive: true }
        );
        this.navButtons.forEach((button) =>
          button.addEventListener('click', () => this.step(Number(button.dataset.direction)))
        );

        requestAnimationFrame(() => {
          this.revealCurrentSet();
          this.updateNav();
        });
      }

      get scrollBehavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      revealCurrentSet() {
        const current = this.viewport.querySelector('[data-current]');
        if (!current) return;

        // Right-align the current set so the previous one peeks in from the left.
        const left = Math.max(0, current.offsetLeft + current.offsetWidth - this.viewport.clientWidth);
        this.viewport.scrollTo({ left, behavior: this.scrollBehavior });
      }

      step(direction) {
        const sets = this.viewport.querySelectorAll('.cart-offer__set');
        const distance = sets.length > 1 ? sets[1].offsetLeft - sets[0].offsetLeft : this.viewport.clientWidth;
        this.viewport.scrollBy({ left: direction * distance, behavior: this.scrollBehavior });
      }

      updateNav() {
        const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
        const [prev, next] = this.navButtons;
        if (!prev || !next) return;

        prev.hidden = next.hidden = maxScroll <= 1;
        prev.disabled = this.viewport.scrollLeft <= 1;
        next.disabled = this.viewport.scrollLeft >= maxScroll - 1;
      }
    }
  );
}
